import { motion } from "framer-motion";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import LeadForm from "@/components/sections/LeadForm";

export default function Contact() {
  return (
    <div data-testid="page-contact">
      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto container-px">
          <div className="grid lg:grid-cols-12 gap-12">
            <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} className="lg:col-span-5 space-y-8">
              <div>
                <p className="eyebrow">Contact</p>
                <h1 className="h-display text-4xl md:text-5xl text-text mt-4">Hai să discutăm despre meniul tău.</h1>
                <p className="mt-5 text-base md:text-lg text-text-soft leading-relaxed">
                  Spune-ne ce tip de afacere ai, iar noi îți recomandăm produsele potrivite. Răspundem rapid și serios.
                </p>
              </div>

              <div className="space-y-5">
                <div className="flex items-start gap-4 card-soft p-5">
                  <div className="h-10 w-10 rounded-xl bg-gold/10 border border-gold/30 flex items-center justify-center shrink-0">
                    <MapPin className="h-4 w-4 text-gold" />
                  </div>
                  <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-text-soft">Sediu</div>
                    <div className="text-text font-medium mt-1">DOTAPAN SRL</div>
                    <div className="text-sm text-text-soft">Strada Parcului nr. 9, Beclean<br />Bistrița-Năsăud</div>
                  </div>
                </div>
                <a href="tel:+40740433894" className="flex items-start gap-4 card-soft p-5" data-testid="contact-phone-link">
                  <div className="h-10 w-10 rounded-xl bg-gold/10 border border-gold/30 flex items-center justify-center shrink-0">
                    <Phone className="h-4 w-4 text-gold" />
                  </div>
                  <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-text-soft">Telefon</div>
                    <div className="text-text font-medium mt-1">+40 740 433 894</div>
                  </div>
                </a>
                <a href="mailto:dotapanromania@gmail.com" className="flex items-start gap-4 card-soft p-5" data-testid="contact-email-link">
                  <div className="h-10 w-10 rounded-xl bg-gold/10 border border-gold/30 flex items-center justify-center shrink-0">
                    <Mail className="h-4 w-4 text-gold" />
                  </div>
                  <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-text-soft">Email</div>
                    <div className="text-text font-medium mt-1">dotapanromania@gmail.com</div>
                  </div>
                </a>
                <a href="https://wa.me/40740433894" target="_blank" rel="noreferrer" className="flex items-start gap-4 card-soft p-5" data-testid="contact-whatsapp-link">
                  <div className="h-10 w-10 rounded-xl bg-[#25d366]/10 border border-[#25d366]/30 flex items-center justify-center shrink-0">
                    <MessageCircle className="h-4 w-4 text-[#25d366]" />
                  </div>
                  <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-text-soft">WhatsApp</div>
                    <div className="text-text font-medium mt-1">Vorbește cu noi acum</div>
                  </div>
                </a>
              </div>
            </motion.div>

            <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.1 }} className="lg:col-span-7">
              <div className="card-soft p-7 md:p-10">
                <h2 className="font-display text-2xl text-text mb-6">Formular ofertă personalizată</h2>
                <LeadForm />
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
}
